export default "https://cdn-static.gokick.com/assets/1a6b0e419037e7f05bc52ad73a019b5bb7bc4745/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";